import Email from '@Shared/Forms/Email';
import useValidation from '@components/Hooks/useValidation';
import useApi from '@components/Hooks/useApi';
import useGlobalState from '@components/Hooks/useGlobalState';
import Icon from '@Shared/Icon';
import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import useSiteConfig from '@components/Hooks/useSiteConfig';


const ForgotPasswordForm: React.FC = () => {

  const [store, dispatch] = useGlobalState();
  const api = useApi(dispatch);
  const site_config = useSiteConfig();

  const [email, setEmail] = useState<string>('');

  const { isNotEmpty, isEmail } = useValidation();

  const isValid = () => {
    return isNotEmpty(email) && isEmail(email);
  }

  const sendPassword = (e: React.FormEvent) => {
    e.preventDefault();
    if (isValid() && site_config) {
      api.sendPassword(email, site_config.domain);
    }
  }

  return (!store.password_sent && site_config) ? (
    <>

      <h2>Enter Your Email Address</h2>
      <p>We&apos;ll send you a message containing a link to reset your password.</p>
      <form style={{ marginTop: -1 }} id='forgot-password-form' onSubmit={sendPassword} className={api.isReallyLoading('sendPassword') ? 'dim' : ''}>

        <Email name='email' value={email} setter={setEmail} title='Email Address' required />

        <Form.Group style={{ paddingTop: 13 }} className='form-group'>
          <Button variant='primary' disabled={!isValid()} type="submit" onClick={sendPassword}>
            <Icon name='envelope' /> Send me an email
          </Button>
        </Form.Group>
      </form>

    </>
  ) : null;
}

export default ForgotPasswordForm;